import { render } from "./OneOnOneListCardLayout.vue?vue&type=template&id=b84e2fb8&scoped=true"
import script from "./OneOnOneListCardLayout.vue?vue&type=script&lang=js"
export * from "./OneOnOneListCardLayout.vue?vue&type=script&lang=js"

import "./OneOnOneListCardLayout.vue?vue&type=style&index=0&id=b84e2fb8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b84e2fb8"

export default script